import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getLoyaltyRewardsPerLevel, deleteRewardFromLevel } from "../../actions/loyalty";
import RewardsPerLevelDisplay from "../../components/Loyalty/RewardsPerLevelDisplay";

const LoyaltyPerLevelScreen = ({ getRewards, rewardsPerLevel, deleteReward }) => {
	useEffect(() => {
		if (getRewards) getRewards();
	}, [getRewards]);

	return (
		<div style={{ display: "flex", flexWrap: "wrap", width: "fit-content", margin: "auto" }}>
			<RewardsPerLevelDisplay
				rewardsPerLevel={rewardsPerLevel.silver}
				deleteReward={(data) => {
					deleteReward(data, getRewards);
				}}
				label="plata"
				level="silver"
				style={{ borderColor: "silver" }}
			/>
			<RewardsPerLevelDisplay
				rewardsPerLevel={rewardsPerLevel.gold}
				deleteReward={(data) => {
					deleteReward(data, getRewards);
				}}
				label="Oro"
				level="gold"
				style={{ borderColor: "gold" }}
			/>
			<RewardsPerLevelDisplay
				rewardsPerLevel={rewardsPerLevel.platinum}
				deleteReward={(data) => {
					deleteReward(data, getRewards);
				}}
				label="Platino"
				level="platinum"
				style={{ borderColor: "gray" }}
			/>
		</div>
	);
};

const mapStateToProps = ({ loyalty }) => {
	return { rewardsPerLevel: loyalty.rewardsPerLevel };
};

const actions = {
	getRewards: getLoyaltyRewardsPerLevel,
	deleteReward: deleteRewardFromLevel,
};

export default connect(mapStateToProps, actions)(LoyaltyPerLevelScreen);
